module.exports = __webpack_public_path__ + "img/qrcode-harmony.2c632598.svg";